export enum NodeTypesEnum {
  TraceSpan = 'traceSpan',
  TestSpan = 'testSpan',
}

export const MAX_DAG_NODES = 200;
